import { SampleTable, SingleTableBoxScene } from "@/shared/components/ui";
import { Grid } from "@mui/material";
import { useGetIncidents } from "../actions/noc-module.actions";
import { Incidents } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { ROUTER_PATHS } from "@/shared";
import { useEffect, useState } from "react";
import { useTableColumnsIncidents } from "../hooks/useTableColumnsIncidents";
import { Add } from "@mui/icons-material";

export default function TabIncidenciasNoc() {

    const ordenesDeTrabajoNocParametrosPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosIncidenciaCrearNav;

    const { columnsIncidents } = useTableColumnsIncidents();

    const [listaIncidencias, setListaIncidencias] = useState<any[]>([]);
    const useActivityTypeMutation = useGetIncidents();

    useEffect(() => {
        const fetchData = async () => {
            const response = await useActivityTypeMutation.mutateAsync([]);
            setListaIncidencias(response.data ?? []);
        };
        fetchData();
    }, []);

    return (
        <SingleTableBoxScene
            title={``}
            textRedirect={"Crear Incidencia"}
            iconRedirect={<Add />}
            urlRedirect={`${ordenesDeTrabajoNocParametrosPage}`}
            visibleReport={true}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>

                </Grid>
                <Grid item xs={12}>
                    <SampleTable<Incidents>
                        columns={columnsIncidents}
                        data={listaIncidencias}
                    />
                </Grid>
            </Grid>
        </SingleTableBoxScene>
    );
}